import { TabPanel, TabView } from "primereact/tabview";
import "./MainLayoutConfigView.scss";
import BoxView from "./tabs/boxtab/BoxView";
import PatientCallerView from "./tabs/patientcallertab/PatientCallerView";
import { useLocationConfigContext } from "./context/LocationConfigContext";
import TotemView from "./tabs/totemtab/TotemView";
import EstablishmentsView from "./tabs/establishments/EstablishmentsView";
import SectorView from "./tabs/sectortab/SectorView";
import OfficeView from "./tabs/officetab/OfficeView";
import RoomView from "./tabs/roomtab/RoomView";
import BedView from "./tabs/bedtab/BedView";
import useResizeListener from "../../hooks/useResizeListener";
import MobileTabSelector, { MobileTabSelectorOption } from "./components/MobileTabSelector";

export const LocationConfigTab = {
    ESTABLISHMENT: { id: 0, name: "Establecimiento" },
    SECTOR: { id: 1, name: "Sector" },
    OFFICE: { id: 2, name: "Consultorio" },
    ROOM: { id: 3, name: "Habitación" },
    BED: { id: 4, name: "Camas" },
    BOX: { id: 5, name: "Puesto de atención" },
    PATIENTCALLER: { id: 6, name: "Llamador" },
    TOTEM: { id: 7, name: "Tótem" },
};

const locationTabOptions = [
    LocationConfigTab.ESTABLISHMENT,
    LocationConfigTab.SECTOR,
    LocationConfigTab.OFFICE,
    LocationConfigTab.ROOM,
    LocationConfigTab.BED,
    LocationConfigTab.BOX,
    LocationConfigTab.PATIENTCALLER,
    LocationConfigTab.TOTEM,
];

const locationMobileTabOptions: MobileTabSelectorOption[] = locationTabOptions.map((tab) => ({
    id: tab.id,
    label: tab.name,
}));

export default function MainLayoutConfigView() {
    const isMobile = useResizeListener(768);
    const { activeTab, setActiveTab } = useLocationConfigContext();

    return (
        <div className="location-config-view viewContainer bg-white pd-4">
            <div className="header-row">
                <h1 className="title mt-2">Locaciones</h1>
                {isMobile ? (
                    <MobileTabSelector
                        id="locationtabselectorid"
                        className="location-mobile-tab-selector"
                        value={activeTab}
                        options={locationMobileTabOptions}
                        onChange={(id) => setActiveTab(Number(id))}
                        ariaLabel="Seleccionar tab de locaciones"
                    />
                ) : (
                    <TabView
                        id="tabcontainer"
                        className="tab-component overflow-x-auto"
                        activeIndex={activeTab}
                        onTabChange={(e) => setActiveTab(e.index)}
                    >
                        <TabPanel key={"tabestablishment"} header={LocationConfigTab.ESTABLISHMENT.name} />
                        <TabPanel key={"tabsector"} header={LocationConfigTab.SECTOR.name} />
                        <TabPanel key={"taboffice"} header={LocationConfigTab.OFFICE.name} />
                        <TabPanel key={"tabroom"} header={LocationConfigTab.ROOM.name} />
                        <TabPanel key={"tabbed"} header={LocationConfigTab.BED.name} />
                        <TabPanel key={"tabbox"} header={LocationConfigTab.BOX.name} />
                        <TabPanel key={"tabcaller"} header={LocationConfigTab.PATIENTCALLER.name} />
                        <TabPanel key={"tabtotem"} header={LocationConfigTab.TOTEM.name} />
                    </TabView>
                )}
            </div>

            <div>
                {activeTab === LocationConfigTab.ESTABLISHMENT.id && <EstablishmentsView />}
                {activeTab === LocationConfigTab.SECTOR.id && <SectorView />}
                {activeTab === LocationConfigTab.OFFICE.id && <OfficeView />}
                {activeTab === LocationConfigTab.ROOM.id && <RoomView />}
                {activeTab === LocationConfigTab.BED.id && <BedView />}
                {activeTab === LocationConfigTab.BOX.id && <BoxView />}
                {activeTab === LocationConfigTab.PATIENTCALLER.id && <PatientCallerView />}
                {activeTab === LocationConfigTab.TOTEM.id && <TotemView />}
            </div>
        </div>
    );
}
